import { useEffect, useState } from 'react';
import moment from 'moment-timezone';

const getRemaining = (target) => {
  const diff = moment.duration(target.diff(moment()));
  if (diff.asSeconds() <= 0) return null;
  return {
    days: Math.floor(diff.asDays()),
    hours: diff.hours(),
    minutes: diff.minutes(),
    seconds: diff.seconds(),
  };
};

// Live countdown to a Berlin-time deadline. Returns null once the deadline has passed.
const useDeadline = (deadline) => {
  const [remaining, setRemaining] = useState(() => getRemaining(moment.tz(deadline, 'Europe/Berlin')));

  useEffect(() => {
    const target = moment.tz(deadline, 'Europe/Berlin');
    const tick = () => setRemaining(getRemaining(target));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [deadline]);

  return remaining;
};

export default useDeadline;
